export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const fmtDate = (s, opts) =>
  s
    ? new Date(`${s}T00:00:00`).toLocaleDateString("it-IT", opts || { weekday: "short", day: "2-digit", month: "short" })
    : "-";

export const fmtLongDate = (s) => fmtDate(s, { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const STATUS = {
  in_attesa: { label: "In attesa di approvazione", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  confermato: { label: "Confermato", cls: "bg-[#61a229]/15 text-[#3f6d18] border-[#61a229]/30" },
  in_corso: { label: "In corso", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  sospeso: { label: "Sospeso", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  completato: { label: "Completato", cls: "bg-slate-900 text-white border-slate-900" },
  rifiutato: { label: "Rifiutato", cls: "bg-red-100 text-red-700 border-red-200" },
  annullato: { label: "Annullato", cls: "bg-slate-100 text-slate-500 border-slate-300 line-through" },
  approvato: { label: "Approvato", cls: "bg-[#61a229]/15 text-[#3f6d18] border-[#61a229]/30" },
};

export const KIND = { intervento: "Intervento tecnico", sopralluogo: "Sopralluogo", cantiere: "Cantiere" };

export const ABSENCE_TYPES = { ferie: "Ferie", permesso: "Permesso", malattia: "Malattia", altro: "Altro" };

export function timeCost(hours, rate, fraction) {
  const minutes = Math.ceil(Math.round(Math.max(Number(hours) || 0, 0) * 60 * 1e4) / 1e4 / fraction) * fraction;
  return { minutes, cost: Math.round(((rate * minutes) / 60) * 100) / 100 };
}

export function pricingFor(cfg, kind, eqKey) {
  if (!cfg) return { call_fee: 0, hourly_rate: 0 };
  if (kind === "sopralluogo") return cfg.survey;
  const eq = cfg.equipment.find((e) => e.key === eqKey) || cfg.equipment[cfg.equipment.length - 1];
  return { call_fee: eq.call_fee, hourly_rate: eq.hourly_rate };
}

export const mapsLink = (job) =>
  job?.location?.coordinates
    ? `https://www.google.com/maps/dir/?api=1&destination=${job.location.coordinates[1]},${job.location.coordinates[0]}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${job?.client?.address || ""} ${job?.client?.city || ""}`)}`;

export const ackLate = (j) => j.tech_ack === "in_attesa" && !!j.ack_reminded_at;
